const REWARDS = [
  { marker: "🎴", image: "/assets/resource-emojis/card.webp", label: "Крутки" },
  { marker: "💎", image: "/assets/resource-emojis/crystal.webp", label: "Кристаллы" },
  { marker: "🧰", image: "/assets/case-light-DVdfIUL2.webp", label: "Лайт-кейс" },
];

// Reward names are the same persisted strings displayed by /gift in the bot.
export function giftRewardView(name) {
  const reward = REWARDS.find(item => name.includes(item.marker));
  if (!reward) return null;
  const amount = name.match(/\d+/)?.[0];
  return { ...reward, amount: amount || "", jackpot: name.includes("Джекпот") };
}
